package org.vreo.devicehub.features.core.presentation.components.configTextField

import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

/**
 * Config text field. Displays text field with label and value.
 *
 * @param label label of the text field
 * @param value value of the text field
 * @param onValueChange action handler for value change
 * @param modifier modifier for the text field
 * @param isError indicates if the text field's current value is in error
 * @param max maximum value of the text field (added to label for indication)
 * @param min minimum value of the text field (added to label for indication)
 */
@Composable
fun ConfigTextField(
    value: String,
    onValueChange: (String) -> Unit,
    modifier: Modifier = Modifier,
    isError: Boolean = false,
    label: String? = null,
    max: String? = null,
    min: String? = null
) {
    val fullLabel = if (label != null && max != null && min != null) {
        "$label ($min - $max)"
    } else label

    OutlinedTextField(
        label = {
            if (fullLabel != null) {
                Text(fullLabel)
            }
        },
        singleLine = true,
        isError = isError,
        value = value,
        onValueChange = {
            onValueChange(it)
        },
        shape = MaterialTheme.shapes.small,
        modifier = modifier.fillMaxWidth()
    )
}